import { render } from "./TemasNavigation.vue?vue&type=template&id=471615b2&scoped=true"
import script from "./TemasNavigation.vue?vue&type=script&lang=js"
export * from "./TemasNavigation.vue?vue&type=script&lang=js"

import "./TemasNavigation.vue?vue&type=style&index=0&id=471615b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-471615b2"]])

export default __exports__